var $18faaf4c3266f94f$exports = {};
$18faaf4c3266f94f$exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};


export {$18faaf4c3266f94f$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
